import { FC } from 'react';

type Props = {
  message?: string;
};
const LoadingIndicator: FC<Props> = ({ message }) => {
  return (
    <span className='indicator-progress' style={{ display: 'block' }}>
      {message ?? 'Please wait...'} <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
    </span>
  );
};

export default LoadingIndicator;
